module.exports = __webpack_public_path__ + "assets/images/sizeofboat-01.59306c48cc768f0a7311a32c8be20055.svg";